import React, { useState } from "react";
import HelperString from 'utils/helper-string'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import i18n from 'utils/i18n'
import Form, { createTranslationField } from 'components/molecules/Form'
import _ from 'lodash'
import Translate from 'utils/translate'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { FormFieldsConstants } from 'utils/constants/form-constants'

const CompanyData = ({ company, saveForm }) => {
	
	const [ formKey, setFormKey ] = useState( HelperString.random() )
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const formFields = [
		{
			name: 'name',
			label: i18n.t('management:form.name.system_name'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		}
	];
	
	// Add the translations
	if( _.size( _languages ) > 0 ) {
		formFields.push( {
			type: FormFieldsConstants.DIVIDER
		} );
		
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			const { name, formField } = createTranslationField( 'name', language );
			
			formFields.push( formField );
			
			const translation = Translate.formField( company, 'title', language );
			if( !_.isEmpty( company ) && translation !== null ) {
				company[ name ] = translation;
			}
		});
	}
	
	return (
		<ThemedBlock
			header={ i18n.t('management:form_block.title_default') }
			shadow
			mediumPadding>
			
			{/* Form */}
			<Form
				key={ HelperString.hash( 'form', formKey ) }
				values={ company }
				fields={ formFields }
				onSubmit={ saveForm }
				disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.COMPANIES ) }
			/>
		</ThemedBlock>
	)
}

export default CompanyData
